'use client';

import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import type { SpacingType } from '@zoomit/primitives';
import { Box, Col, Flex } from '@zoomit/primitives';
import { isMobile } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

type Props = {
  spacing?: SpacingType;
  children: ReactNode;
};

const CommentContainer = (props: Props) => {
  return (
    <Flex md={[{ flexDirection: 'row' }]} justifyContent={'space-between'} flexDirection="column">
      <Col size={12} md={1.7} spacing={{ mb: 'x4' }}>
        <Title spacing={{ mt: 0.2 }} style={{ display: 'inline' }} variant="h5" tag="h3">
          دیدگاه و سوال کاربران
        </Title>
      </Col>
      <Col size={12} md={10}>
        <Box spacing={{ px: isMobile ? 'x4' : 'x0' }} style={{ maxWidth: 872 }}>
          {props.children}
        </Box>
      </Col>
    </Flex>
  );
};

export default CommentContainer;

const Title = styled(Typography)`
  position: relative;
  padding-right: 1.6rem;

  &::after {
    content: '';
    position: absolute;
    top: 0.8rem;
    right: 0;
    transform: translateY(-50%);
    width: 0.4rem;
    height: 2.4rem;
    background-color: ${cssVar(theme.primary1)};
  }
`;
